import {BaseContainerModel} from '../base-container.model';
import {bl_fi_mst_profit_center_RowClass} from '../../dbschema';
import {bl_fi_mst_gl_category_list_hdr_RowClass} from "../../dbschema/bl_fi_mst_gl_category_list_hdr.model";

export class GlCategoryListContainerModel extends BaseContainerModel {
  bl_fi_mst_gl_category_list_hdr: bl_fi_mst_gl_category_list_hdr_RowClass = new bl_fi_mst_gl_category_list_hdr_RowClass();
}
